import {Directive, Injectable} from '@angular/core';
import {AbstractControl, ValidationErrors} from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
@Directive({
    selector: '[appPasswordRequirement]'
})
export class PasswordRequirementDirective {
    constructor() {
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const password = control.value;
        let errors: string[] = [];

        if (password == null || password == "") {
            return null;
        }

        if (!this.hasMinimumLength(password)) {
            errors = errors.concat("length");
        }

        if (!this.hasLowercase(password)) {
            errors = errors.concat("lowercase");
        }

        if (!this.hasUppercase(password)) {
            errors = errors.concat("uppercase");
        }

        if (!this.hasNumber(password)) {
            errors = errors.concat("number");
        }

        if (!this.hasSpecialCharacter(password)) {
            errors = errors.concat("special");
        }

        if (errors.length > 0) {
            return {weakPassword: errors};
        }

        return null;
    }

    private hasMinimumLength(password: string): boolean {
        const regex = /(?=.{8,})/;
        return regex.test(password);
    }

    private hasLowercase(password: string): boolean {
        const regex = /(?=(.*[a-z])+)/;
        return regex.test(password);
    }

    private hasUppercase(password: string): boolean {
        const regex = /(?=(.*[A-Z])+)/;
        return regex.test(password);
    }

    private hasNumber(password: string): boolean {
        const regex = /(?=(.*[0-9])+)/;
        return regex.test(password);
    }

    private hasSpecialCharacter(password: string): boolean {
        const regex = /(?=(.*[.!@#$%^&*()_+={}|'\s\-\[\]])+)/;
        return regex.test(password);
    }
}